<template>
    <CDropdown inNav
               class="c-header-nav-items"
               placement="bottom-end"
               add-menu-classes="pt-0">
        <template #toggler>
            <CHeaderNavLink>
                <div class="c-avatar">
                    <img src="img/avatars/0.jpg"
                         class="c-avatar-img " />
                </div>
            </CHeaderNavLink>
        </template>
        <CDropdownHeader tag="div" class="text-center" color="light">
            <strong>{{ $store.state.identity.username }}</strong>
        </CDropdownHeader>
        <!--<CDropdownItem>
            <CIcon name="cil-bell" /> Updates
            <CBadge color="info" class="ml-auto">{{ itemsCount }}</CBadge>
        </CDropdownItem>
        <CDropdownItem>
            <CIcon name="cil-envelope-open" /> Messages
            <CBadge color="success" class="ml-auto">{{ itemsCount }}</CBadge>
        </CDropdownItem>
        <CDropdownItem>
            <CIcon name="cil-task" /> Tasks
            <CBadge color="danger" class="ml-auto">{{ itemsCount }}</CBadge>
        </CDropdownItem>
        <CDropdownItem>
            <CIcon name="cil-comment-square" /> Comments
            <CBadge color="warning" class="ml-auto">{{ itemsCount }}</CBadge>
        </CDropdownItem>
        <CDropdownHeader tag="div"
                         class="text-center"
                         color="light">
            <strong>Settings</strong>
        </CDropdownHeader>-->
        <CDropdownItem>
            <CIcon name="cil-user" />
            <router-link to="/profile"> Thông tin tài khoản</router-link>
        </CDropdownItem>
        <CDropdownItem v-b-modal.modal-change-password>
            <CIcon name="cil-settings" /> Đổi mật khẩu
            <ModalChangePassword title="Đổi mật khẩu" />
        </CDropdownItem>
        <!--<CDropdownItem>
            <CIcon name="cil-settings" /> Settings
        </CDropdownItem>
        <CDropdownItem>
            <CIcon name="cil-dollar" /> Payments
            <CBadge color="secondary" class="ml-auto">{{ itemsCount }}</CBadge>
        </CDropdownItem>
        <CDropdownItem>
            <CIcon name="cil-file" /> Projects
            <CBadge color="primary" class="ml-auto">{{ itemsCount }}</CBadge>
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem>
            <CIcon name="cil-shield-alt" /> Lock Account
        </CDropdownItem>-->
        <CDropdownItem @click.prevent="logout">
            <CIcon name="cil-lock-locked" /> Đăng xuất
        </CDropdownItem>
        <CDropdownHeader tag="div"
                         class="text-center"
                         color="light">
            <strong>Link phần mềm</strong>
        </CDropdownHeader>
        <template v-for="(item, index) in configUrls">
            <CDropdownItem :href="item.value" :title="item.text">
                <CIcon name="cil-link" />
                <a :href="item.value" :title="item.text" target="_blank">{{item.text}}</a>
            </CDropdownItem>
        </template>

    </CDropdown>
</template>

<script>
    //import modal from '@/components/ModalChangePassword';
    export default {
        name: 'TheHeaderDropdownAccnt',
        data() {
            return {
                //itemsCount: 42
                title: "Đổi mật khẩu",
                configUrls: []
            }
        },
        created() {
            this.loadSystemConfigUrl();
        },
        methods: {
            logout() {
                var vm = this;
                this.$store.dispatch('deauthenticate');
            },
            loadSystemConfigUrl() {
                var vm = this;
                this.$services.get('system-parameters/systems-config-url/list').done((response) => {
                    vm.configUrls = response;
                });
            },
        }
    }
</script>

<style scoped>

    .c-icon {
        margin-right: 0.3rem;
    }
</style>